<template>
  <div class="dispatch-container">
    <!-- 筛选区域 -->
    <!-- <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="派单编号">
          <el-input v-model="filterForm.pai_order_no" placeholder="请输入派单编号" clearable />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="filterForm.order_dh" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="经销商">
          <el-select
            v-model="filterForm.jx_id"
            placeholder="全部"
            clearable
            filterable
          >
            <el-option
              v-for="item in dealerList"
              :key="item.id"
              :label="item.sh_name"
              :value="parseInt(item.id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="派单时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card> -->

    <!-- 派单列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="dispatchList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="pai_order_no" label="派单编号" min-width="220" show-overflow-tooltip />
        <el-table-column prop="brand_name" label="品牌方" min-width="200" show-overflow-tooltip />
        <el-table-column prop="jx_name" label="经销商" min-width="160" show-overflow-tooltip />
        <el-table-column prop="comlist_s1" label="总数量" width="100" align="center" />
        <el-table-column prop="comlist_f1" label="总金额(元)" width="130">
          <template slot-scope="scope">
            <span class="money">¥{{ parseFloat(scope.row.comlist_f1).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="派单时间" width="180" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-view"
              @click.stop="viewDetail(scope.row)"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 派单详情弹窗 -->
    <el-dialog title="派单明细" :visible.sync="detailVisible" width="60%">
      <div v-if="currentDispatch">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="派单编号">{{ currentDispatch.pai_order_no }}</el-descriptions-item>
          <el-descriptions-item label="订单号">{{ currentDispatch.order_dh }}</el-descriptions-item>
          <el-descriptions-item label="经销商">{{ currentDispatch.jx_name }}</el-descriptions-item>
          <el-descriptions-item label="派单时间">{{ currentDispatch.create_time }}</el-descriptions-item>
          <el-descriptions-item label="总数量">{{ currentDispatch.comlist_s1 }}</el-descriptions-item>
          <el-descriptions-item label="总金额">
            <span class="money">¥{{ parseFloat(currentDispatch.comlist_f1).toFixed(2) }}</span>
          </el-descriptions-item>
        </el-descriptions>

        <div style="margin-top: 20px; font-weight: bold;">派单商品明细</div>
        <el-table :data="currentDispatch.mx || []" border style="margin-top: 10px;">
          <el-table-column prop="goods_name" label="商品名称" min-width="200" />
          <el-table-column prop="comlist_s1" label="数量" width="100" />
          <el-table-column prop="comlist_f1" label="单价" width="120">
            <template slot-scope="scope">
              ¥{{ parseFloat(scope.row.comlist_f1).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="小计" width="120">
            <template slot-scope="scope">
              ¥{{ (parseFloat(scope.row.comlist_s1) * parseFloat(scope.row.comlist_f1)).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'DispatchList',
  data () {
    return {
      loading: false,
      dispatchList: [],
      filterForm: {
        pai_order_no: '',
        order_dh: '',
        jx_id: '',
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pages: 0,

      // 经销商列表（用于筛选）
      dealerList: [],

      // 详情弹窗
      detailVisible: false,
      currentDispatch: null
    }
  },
  mounted () {
    this.fetchDealerList()
    this.getDispatchList()
  },
  methods: {
    // 获取派单列表（全部，不传 order_id）
    async getDispatchList () {
      this.loading = true
      try {
        const params = {
          a: 'paiLists',
          sh_id: localStorage.getItem('sh_id'),
          page: this.currentPage,
          page_size: this.pageSize,
          ...this.filterForm
        }
        // 删除空字段
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const res = await request.post('/order/order_pai.php', params)

        if (res.code === '0') {
          this.dispatchList = res.data || []
          this.pages = res.pages || 0
          this.total = this.pages * this.pageSize
        } else {
          this.$message.error(res.msg || '获取派单列表失败')
          this.dispatchList = []
          this.total = 0
        }
      } catch (err) {
        console.error('获取派单列表异常:', err)
        this.$message.error('网络错误，请稍后重试')
        this.dispatchList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // 获取经销商列表（用于筛选下拉）
    async fetchDealerList () {
      try {
        const shId = localStorage.getItem('sh_id')
        const res = await request.post('/admin/shenhe_jiben.php', {
          a: 'lists',
          sh_id: shId,
          page: 1,
          page_size: 200,
          sh_name: '',
          id: '',
          sh_type: '审核通过'
        })
        if (res.code === '0') {
          this.dealerList = res.data || []
        }
      } catch (err) {
        console.error('获取经销商列表失败:', err)
      }
    },

    // 查询
    handleSearch () {
      if (this.dateRange && this.dateRange.length === 2) {
        this.filterForm.start_time = this.dateRange[0]
        this.filterForm.end_time = this.dateRange[1]
      } else {
        this.filterForm.start_time = ''
        this.filterForm.end_time = ''
      }
      this.currentPage = 1
      this.getDispatchList()
    },

    // 重置
    handleReset () {
      this.filterForm = {
        pai_order_no: '',
        order_dh: '',
        jx_id: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.currentPage = 1
      this.getDispatchList()
    },

    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDispatchList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getDispatchList()
    },

    // 查看详情
    viewDetail (row) {
      // 如果当前行未包含 mx，可再请求一次明细（或者接口已返回完整数据）
      // 此处假设后端返回的 data 中包含 mx 数组
      this.currentDispatch = row
      this.detailVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.money { color: #ee530c; }
.dispatch-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
